import {
	ReactElement,
	useMemo
} from "react";
import {
	AbsoluteCoordinate,
	DropOverAlignmentValue,
	ToolbarAction,
	TreeAccordion
} from "client/Components";
import { useFollowCategoryAction } from "./useFollowCategoryAction";

type MenuContext = { categoryId: number; };

export type FollowCategoryProps = {
	categoryId: number;
	categoryName: string;
	isFollowing: boolean;
	dropOverTargetAlignment?: DropOverAlignmentValue | AbsoluteCoordinate;
	dropOverContentAlignment?: DropOverAlignmentValue;
};

export const FollowCategory = (props: FollowCategoryProps): ReactElement => {
	const {
		categoryId,
		categoryName,
		isFollowing,
	} = props;

	const followAction: ToolbarAction<MenuContext> = useFollowCategoryAction<MenuContext>(
		categoryId,
		isFollowing
	);

	const actions = useMemo(
		(): ReadonlyArray<ToolbarAction<MenuContext>> => [
			followAction
		],
		[followAction]
	);

	const actionContext = useMemo(
		(): MenuContext => {
			return { categoryId };
		},
		[categoryId]
	);

	return (
		<TreeAccordion.ActionList
			actions={actions}
			context={actionContext}
			dropOverTargetAlignment="bl"
			dropOverContentAlignment="tl"
			menuTitle={categoryName}
		/>
	);
};

FollowCategory.displayName = "FollowCategory";